
  import { controlType } from "constant";
  import { shouldDisplayBatteryInfo } from "../_helperFunctions/shouldDisplayBatteryInfo";
  
  export const shouldDisplayBattery = (car, getUserRole) => {
    if (car.UseVoltage) {
      return true;
    }

    // showing percentage for low battery
    if (car.BatteryLevel <= 25) {
      return true;
    }

    if (!shouldDisplayBatteryInfo(getUserRole)) {
      return false;
    }

    if (car.CarControlType != controlType.LIN || (car.CarControlType == controlType.LIN && car.BatteryLevel > 25)) {
      return true;
    }

    return false;
  }